const pagination = {
	offset: 0,
	limit: 25,
	__typename: 'Pagination',
};

export { pagination };
